<template>
  <div id="calendar"
       :class="{'change':isChange}">
    <!-- 年份 月份 -->
    <div class="year-month">
      <div class="left"
           @click="leftSliding"> &#139; </div>
      <div class="center">{{currentYear}}年{{currentMonth}}月</div>
      <div class="right"
           @click="rightSliding"> &#155; </div>
    </div>
    <!-- 星期 -->
    <ul class="weekdays">
      <li v-for="(vo,index) in weekdays"
          v-text="vo"
          :key="index"></li>
    </ul>
    <!-- 日期 -->
    <ul class="days"
        :class="{'fadeOut':fadeOut, 'fadeIn':fadeIn, 'fadeOutR':fadeOutR, 'fadeInR':fadeInR}"
        @touchstart="allTouchStart"
        @touchend="allTouchEnd"
        @touchstart.stop="touchStart"
        @touchend.stop="touchEnd">
      <!-- 核心 v-for循环 每一次循环用<li>标签创建一天 -->
      <li v-for="(dayobject,index) in days"
          :class="{'weekend':(index%7 === 0)||((index+1)%7 === 0)}"
          :key="index">
        <!--本月-->
        <!--如果不是本月 改变类名加灰色-->
        <div v-if="dayobject.day.getMonth()+1 !== currentMonth"
             @click="otherMonth(dayobject.day.getDate())"
             class="other-month">
          {{ dayobject.day.getDate() }}
        </div>
        <!--如果是本月 还需要判断是不是这一天-->
        <div v-else @click="getDayMessage(currentYear,currentMonth,dayobject.day.getDate())"
             class="everyDay">
          <!--今天 同年同月同日-->
          <div v-if="dayobject.day.getFullYear() === new Date().getFullYear() && dayobject.day.getMonth() === new Date().getMonth() && dayobject.day.getDate() === new Date().getDate()"
               class="active">
            {{ dayobject.day.getDate() }}
          </div>
          <div v-else
               :class="{'otherday':dayobject.day.getDate() === otherDay}">
            {{ dayobject.day.getDate() }}
          </div>

          <div class="pointBoxV"
               type="flex"
               justify="center">
            <div class="point"
                 v-for="(item, index) in dayobject.colors"
                 :key="index"
                 :style="{ backgroundColor: item }"></div>
          </div>
        </div>
      </li>
    </ul>
    <!--背景色-->
    <div class="background"
         :class="{'change':isChange}">
      <div v-for="(value,index) in 5"
           :class="{'dbg':(index%2===0),'lbg':(index%2!==0)}"
           :key="index"></div>
    </div>
    <div class="example">
      <div class="item c10">正常</div>
      <div class="item k20">异常</div>

    </div>
  </div>
</template>

<script>
// import { calendarDataApi } from '../requset/api'
export default {
  name: 'v-calendar',
  data() {
    return {
      currentDay: 1,
      currentMonth: 1,
      currentYear: 2020,
      currentWeek: 1,
      newWeek: 1,
      days: [],
      weekdays: ['一', '二', '三', '四', '五', '六', '日'],
      // 上下滑动的鼠标位置
      positionSX: '',
      positionEX: '',
      positionSY: '',
      positionEY: '',
      isChange: false,
      // 左右滑动动画的初始状态
      show: true,
      fadeOut: false,
      fadeIn: false,
      fadeOutR: false,
      fadeInR: false,
      monthList: [],
      status: '',
      otherDay: '',
      selectedDate: '',
    }
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    list() {
      this.initData(this.selectedDate)
    },
  },
  mounted() {
    this.initData(null)
  },
  methods: {
    getDayMessage(y, m, d) {
      this.getCurrentWeek(y, m, d)
      const str = this.formatDate(y, m, d)
      this.$emit('click', str, m, d)
      this.otherDay = d
    },
    getDayMessageForRender(y, m, d) {
      this.getCurrentWeek(y, m, d)
      // const str = this.formatDate(y, m, d)
      this.otherDay = d
    },
    getCurrentWeek(y, m, d) {
      const w = `${y}-${m}-${d}`
      const weekArr = w.split('-')
      const weeks = new Date(weekArr[0], parseInt(weekArr[1] - 1), weekArr[2])
      this.newWeek = weeks.getDay()
    },
    otherMonth(day) {
      if (day < 15) {
        this.rightSliding()
      } else if (day > 15) {
        this.leftSliding()
      }
    },
    addSchedule() {
      this.$emit('add')
    },
    // 向下滑监听坐标
    allTouchStart(e) {
      // 开始x轴坐标
      this.positionSX = e.changedTouches[0].clientX
      // 开始y轴坐标
      this.positionSY = e.changedTouches[0].clientY
    },
    allTouchEnd(e) {
      // 结束x轴坐标
      this.positionEX = e.changedTouches[0].clientX
      // 结束y轴坐标
      this.positionEY = e.changedTouches[0].clientY
      const distanceY = this.positionEY - this.positionSY
      const distanceX = this.positionSX - this.positionEX
      // 判断滑动的方向
      if (distanceY < -30 && Math.abs(distanceY) > Math.abs(distanceX)) {
        this.isChange = true
      }
      if (distanceY > 30 && Math.abs(distanceY) > Math.abs(distanceX)) {
        this.isChange = false
      }
    },

    // 监听左右滑动坐标
    touchStart(e) {
      // 开始x轴坐标
      this.positionSX = e.changedTouches[0].clientX
      // 开始y轴坐标
      this.positionSY = e.changedTouches[0].clientY
    },
    touchEnd(e) {
      this.show = !this.show
      // 结束x轴坐标
      this.positionEX = e.changedTouches[0].clientX
      // 结束y轴坐标
      this.positionEY = e.changedTouches[0].clientY
      const distanceY = this.positionEY - this.positionSY
      const distanceX = this.positionSX - this.positionEX
      // 判断滑动 的方向
      if (distanceX > 30 && Math.abs(distanceY) < Math.abs(distanceX)) {
        this.rightSliding()
      }
      if (distanceX < -30 && Math.abs(distanceY) < Math.abs(distanceX)) {
        this.leftSliding()
      }
    },
    // 向右滑动
    rightSliding() {
      const self = this
      self.pickNext(self.currentYear, self.currentMonth)
      self.fadeOut = true
      self.fadeIn = false
      self.fadeInR = false
      self.fadeOutR = false
      setTimeout(function () {
        self.fadeIn = true
        self.fadeOut = false
        self.fadeOutR = false
        self.fadeInR = false
      }, 300)
    },
    // 向左滑动
    leftSliding() {
      const self = this
      self.pickPre(self.currentYear, self.currentMonth)
      self.fadeOutR = true
      self.fadeInR = false
      self.fadeOut = false
      self.fadeIn = false
      setTimeout(function () {
        self.fadeInR = true
        self.fadeOutR = false
        self.fadeOut = false
        self.fadeIn = false
      }, 300)
    },
    initData(cur) {
      let date
      if (cur) {
        date = new Date(cur)
      } else {
        //中国当前标准时间 Wed Apr 07 2021 18:57:39 GMT+0800 (中国标准时间)
        const now = new Date()
        //年月日2021-04-01
        const t = this.formatDate(now.getFullYear(), now.getMonth() + 1, 1)
        //当前月的第一天  Thu Apr 01 2021 08:00:00 GMT+0800 (中国标准时间)
        const d = new Date(t)

        //Wed May 05 2021 08:00:00 GMT+0800 (中国标准时间)
        d.setDate(35)
        console.log(d, 'd')
        // 判断是否是跨年
        if (now.getFullYear() < d.getFullYear()) {
          date = new Date(now.getFullYear(), now.getMonth(), 1)
        } else {
          date = new Date(this.formatDate(d.getFullYear(), d.getMonth(), 1))
        }
        // date = new Date(this.formatDate(d.getFullYear(), d.getMonth(), 1))
      }
      this.currentDay = date.getDate()
      this.currentYear = date.getFullYear()
      this.currentMonth = date.getMonth() + 1
      this.currentWeek = date.getDay()
      if (!cur || !this.otherDay) {
        this.otherDay = new Date().getDate()
      }
      /**新增 **/
      if (this.currentWeek == 0) {
        this.currentWeek = 7
      }
      const str = this.formatDate(
        this.currentYear,
        this.currentMonth,
        this.currentDay
      )
      this.days.length = 0
      // 今天是周日，放在第一行第7个位置，前面6个
      // 初始化本周
      /**新增-1 **/
      for (let i = this.currentWeek - 1; i >= 0; i--) {
        const d = new Date(str)
        d.setDate(d.getDate() - i)
        const dayobject = {} // 用一个对象包装Date对象 以便为以后预定功能添加属性
        dayobject.day = d
        // dayobject.status = ''
        this.days.push(dayobject) // 将日期放入data 中的days数组 供页面渲染使用
      }
      /**新增 **/
      let currentDate = new Date(str)
      let lastDay = this.currentMonthLast(currentDate).getDate() //这个月最后一天
      //这个月 除了第一周以后还有多少天
      // console.log('lastDay', lastDay) //这个月的天数
      // console.log('currentWeek', this.currentWeek) //这个月的天数
      /**新增 **/
      let maxCount = 35
      if (lastDay + this.currentWeek - 1 > 35) {
        maxCount = 42
      }
      // 其他周
      for (let i = 1; i <= maxCount - this.currentWeek; i++) {
        const d = new Date(str)
        d.setDate(d.getDate() + i)
        const dayobject = {}
        dayobject.day = d
        // dayobject.status = ''
        this.days.push(dayobject)
      }
      // 填入其他信息
      for (let i = 0; i < this.days.length; i++) {
        for (let j = 0; j < this.list.length; j++) {
          if (this.timeFormatter(this.days[i].day) === this.list[j].day) {
            this.days[i].colors = this.list[j].colors
            this.days[i].bgColor = this.list[j].bgColor
            // this.days[i].status = this.list[j].status.split(',')
          }
        }
      }
      //console.log(this.days, 'days')
      // 选中日期在其他月份是否超出最大日期判断
      const arr = []
      for (let j = 0, length = this.days.length; j < length; j++) {
        if (this.days[j].day.getMonth() + 1 === this.currentMonth) {
          arr.push(this.days[j].day.getDate())
        }
      }

      const maxDate = Math.max.apply(null, arr)
      if (this.otherDay > maxDate) {
        this.otherDay = maxDate
      }

      this.getDayMessageForRender(
        this.currentYear,
        this.currentMonth,
        this.otherDay
      )
    },
    /**新增 **/
    currentMonthLast(date) {
      let currentMonth = date.getMonth()
      let nextMonth = ++currentMonth
      let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
      let oneDay = 1000 * 60 * 60 * 24
      return new Date(nextMonthFirstDay - oneDay)
    },
    // 上个月信息
    pickPre(year, month) {
      const d = new Date(this.formatDate(year, month, 1))
      d.setDate(0)
      this.selectedDate = this.formatDate(d.getFullYear(), d.getMonth() + 1, 1)
      this.initData(this.selectedDate)
      this.$emit('change', this.selectedDate)
    },
    // 下个月信息
    pickNext(year, month) {
      const d = new Date(this.formatDate(year, month, 1))
      d.setDate(35)
      this.selectedDate = this.formatDate(d.getFullYear(), d.getMonth() + 1, 1)
      this.initData(this.selectedDate)
      this.$emit('change', this.selectedDate)
    },
    timeFormatter(time) {
      if (time) {
        const d = new Date(time)
        const timeString = `${this.timeformat(
          d.getFullYear()
        )}-${this.timeformat(d.getMonth() + 1)}-${this.timeformat(d.getDate())}`
        return timeString
      } else {
        return ''
      }
    },
    timeformat(val) {
      return val < 10 ? `0${val}` : val
    },
    // 补零处理
    formatDate(year, month, day) {
      let y = year
      let m = month
      if (m < 10) m = '0' + m
      let d = day
      if (d < 10) d = '0' + d
      return y + '-' + m + '-' + d
    },
  },
}
</script>

<style lang="less">
#calendar {
  width: 100%;
  height: auto;
  margin: 0 auto;
  transition: all 0.5s;
  overflow: hidden;
  background: #fafafa;
  box-shadow: 0px 1px 0px 1px #ddd;
  .change {
    height: 250px !important;
  }
  .year-month {
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: #fff;
    color: #333;
    .left {
      flex: 1;
      text-align: right;
      font-size: 20px;
      color: #333;
      font-weight: 600;
    }
    .center {
      flex: 1;
      text-align: center;
    }
    .right {
      flex: 1;
      text-align: left;
      font-size: 20px;
      color: #333;
      font-weight: 600;
    }
  }
  .weekdays {
    margin: 0;
    height: 40px;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    flex-wrap: wrap;
    color: #888;
    justify-content: space-around;
    background-color: #fff;
    li {
      display: inline-block;
      width: 13.6%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: inherit;
      box-sizing: border-box;
    }
  }
  .days {
    padding: 0;
    background: #ffffff;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    border-left: 1px solid #e4e7ea;
    border-top: 1px solid #e4e7ea;
    li {
      list-style-type: none;
      display: inline-block;
      width: 14%;
      height: 40px;
      text-align: center;
      // padding-top: 2px;
      font-size: 13px;
      color: #000;
      border-right: 1px solid #e4e7ea;
      border-bottom: 1px solid #e4e7ea;
      font-weight: 600;
      box-sizing: border-box;
    }

    .active {
      background: #00b8ec;
      color: #fff;

      width: 100%;
      height: 38px;
      margin-top: -5px;
      padding-top: 5px;
    }
    .other-month {
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #a2a2a2;
      padding-top: 3px;
    }
    .everyDay {
      // width: 40px;
      // height: 40px;
      // margin: auto;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      padding-top: 3px;
      box-sizing: border-box;
      height: 100%;
    }

    .pointBoxV {
      margin-top: 5px;

      margin-left: 0px;
      display: flex;
      justify-content: center;
    }
    .point {
      width: 6px;
      height: 6px;
      border-radius: 50%;
    }
    .otherday {
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 30%;
    }
  }
  .days li:hover {
    background: #e1e1e1;
  }
  .fadeOut {
    animation-name: fadeOut;
    animation-duration: 0.5s;
    animation-timing-function: ease-in-out;
  }
  .fadeOutR {
    animation-name: fadeOutR;
    animation-duration: 0.5s;
    animation-timing-function: ease-in-out;
  }
  .fadeIn {
    animation-name: fadeIn;
    animation-duration: 0.5s;
    animation-timing-function: ease-in-out;
  }
  .fadeInR {
    animation-name: fadeInR;
    animation-duration: 0.5s;
    animation-timing-function: ease-in-out;
  }
  .background {
    position: absolute;
    top: 100px;
    height: 211px;
    width: 100%;
    z-index: -1;
    overflow: hidden;
    transition: all 0.5s;
    .dbg {
      background-color: #e1e1e1;
      height: 42.2px;
    }
    .lbg {
      background-color: #d5d5d5;
      height: 42.2px;
    }
  }
  .example {
    display: flex;
    width: 100%;
    align-items: center;

    justify-content: space-around;
    background-color: #f2f2f2;
    .item {
      height: 34px;
      line-height: 34px;
      // flex: 1;
      // text-align: left;
      font-size: 16px;
      color: #777;
    }
    .item::before {
      content: '';
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 3px;
      width: 8px;
      height: 8px;
      background-color: rgb(205, 139, 12);
      border-radius: 50%;
    }
    .c10::before {
      background-color: rgb(0, 205, 102);
    }

    .k20::before {
      background-color: rgb(233, 43, 33);
    }
  }
}

@keyframes fadeOut {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(-100%);
    opacity: 0;
  }
}
@keyframes fadeIn {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes fadeOutR {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    opacity: 0;
  }
}
@keyframes fadeInR {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>